import { useCallback } from 'react';
import {
  SHOW_INACTIVE_PROJECTS_OPTION_ID,
  SHOW_CLOSED_TASKS_OPTION_ID
} from '../constants';

const useMoveTimeChangeHandlers = ({ setMoveTimeData }) => {
  const handleProjectChange = useCallback(
    (type, value, event) => {
      if (value?.id === SHOW_INACTIVE_PROJECTS_OPTION_ID)
        setMoveTimeData(prev => ({
          ...prev,
          [type]: {
            ...prev[type],
            filter: {
              ...prev[type].filter,
              showInactiveProjects: event.target.checked
            }
          }
        }));
      else
        setMoveTimeData(prev => ({
          ...prev,
          [type]: {
            ...prev[type],
            project: value,
            task: null,
            filter: {
              ...prev[type].filter,
              showClosedTasks: false
            }
          },
          ...(type === 'destination' ? { billingStatus: null } : {})
        }));
    },
    [setMoveTimeData]
  );

  const handleTaskChange = useCallback(
    (type, value, event) => {
      if (value?.id === SHOW_CLOSED_TASKS_OPTION_ID)
        setMoveTimeData(prev => ({
          ...prev,
          [type]: {
            ...prev[type],
            filter: {
              ...prev[type].filter,
              showClosedTasks: event.target.checked
            }
          }
        }));
      else
        setMoveTimeData(prev => ({
          ...prev,
          [type]: {
            ...prev[type],
            task: value
          },
          ...(type === 'destination' ? { billingStatus: null } : {})
        }));
    },
    [setMoveTimeData]
  );

  const handleSourceProjectChange = useCallback(
    (value, event) => handleProjectChange('source', value, event),
    [handleProjectChange]
  );
  const handleDestinationProjectChange = useCallback(
    (value, event) => handleProjectChange('destination', value, event),
    [handleProjectChange]
  );

  const handleSourceTaskChange = useCallback(
    (value, event) => handleTaskChange('source', value, event),
    [handleTaskChange]
  );
  const handleDestinationTaskChange = useCallback(
    (value, event) => handleTaskChange('destination', value, event),
    [handleTaskChange]
  );

  const handleBillingStatusChange = useCallback(
    billingStatus => {
      setMoveTimeData(prev => ({
        ...prev,
        billingStatus
      }));
    },
    [setMoveTimeData]
  );

  const handleCriteriaChange = useCallback(
    value => {
      setMoveTimeData(prev => ({
        ...prev,
        criteria: value
      }));
    },
    [setMoveTimeData]
  );

  return {
    handleSourceProjectChange,
    handleSourceTaskChange,
    handleDestinationProjectChange,
    handleDestinationTaskChange,
    handleBillingStatusChange,
    handleCriteriaChange
  };
};

export default useMoveTimeChangeHandlers;
